<div class="web-frame">
  <iframe [src]="url | safeUrl" frameborder="0"></iframe>
</div>
